export class Update {
  success: boolean;
  info: string;

  constructor(success: boolean, info: string) {
    this.success = success;
    this.info = info;
  }
}
